export class DirtyOutKeyItemDataKey {
  public old_share_id: number;
  public old_share_sequence: number;
  public new_share_key: string;
  public blob_id: number;
  public data_key: string;
  public share_key: string;
}

export class DirtyOutKeyItemShareKey {
  public sharekey_id: string;
  public enc_share_key: string;
  public servtime: number;
}
